<template>
  <!-- ケアオーケストレーター施設管理 -->
  <div id="ExternalHospitalContents">
      <div class="labelTitle lable">ケア オーケストレーター　施設管理</div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
              <template v-if="editMode">
                  <tr><th>医療機関名<span class="require"/></th><td><input type="text" maxlength="100" v-model="data.medicalInstitutionName" class="edit" name="医療機関名" validate="required"/></td></tr>
                  <tr><th>診療科<span class="require"/></th><td><input type="text" maxlength="100" v-model="data.department" class="edit" name="診療科" validate="required"/></td></tr>
                  <tr v-if="isDealer()"><th>担当支店<span class="require"/></th>
                    <td>
                        <select v-model="data.branchOfficeCode">
                          <option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
                        </select>
                    </td>
                  </tr>
                  <tr v-if="isDealer()"><th></th><td>※医療機関を担当するPhilipsの支店を選択してください。ご不明の場合はPhilips営業担当者にご連絡ください。</td></tr>
                  <tr>
                    <th>
                      郵便番号<span class="require"/>
                    </th>
                    <td>
                      <input
                        type="text"
                        maxlength="7"
                        v-model="data.postcode"
                        class="edit"
                        :class="{'border-red': invalidPostcode}"
                        name="郵便番号"
                        validate="required|numeric"
                        :placeholder="postcodePlaceholder"
                      />
                      <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                    </td>
                  </tr>
                  <tr><th>都道府県<span class="require"/></th><td><input type="text" maxlength="20" v-model="data.prefecture" class="edit" name="都道府県" validate="required"/></td></tr>
                  <tr><th>市町村<span class="require"/></th><td><input type="text" maxlength="100" v-model="data.city" class="edit" name="市町村" validate="required"/></td></tr>
                  <tr><th>住所1<span class="require"/></th><td><input type="text" maxlength="100" v-model="data.address1" class="edit" name="住所1" validate="required"/></td></tr>
                  <tr><th>住所2</th><td><input type="text" maxlength="100" v-model="data.address2"/></td></tr>
                  <tr>
                    <th>
                      電話番号<span class="require"/>
                    </th>
                    <td>
                      <input
                        type="text"
                        maxlength="11"
                        v-model="data.telephone"
                        class="edit"
                        :class="{'border-red': invalidPhoneNumber}"
                        name="電話番号"
                        validate="required|numeric"
                        :placeholder="phonePlaceholder"
                      />
                      <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                    </td>
                  </tr>
                  <tr><th>クライアント認証<span class="require"/></th>
                      <td>
                          <div class="block">
                          <b-radio class="td_radio" name="clientAuth" v-model="data.certificationFlag" :native-value="true">有効にする</b-radio>
                          <b-radio class="td_radio" name="clientAuth" v-model="data.certificationFlag" :native-value="false">有効にしない</b-radio>
                          </div>
                      </td>
                  </tr>
                  <tr><th></th>
                      <td>
                      <span class="urgency_caution" style="margin-left:0px;">※医療情報システムの安全管理に関するガイドライン（厚生労働省）では、医療機関等に向けて「不特定の端末から接続されるリスクがある場合、TLS クライアント認証を行うこと」が求められています。</span><br/>
                      ※クライアント認証機能を有効にした場合、Philipsが発行する証明書をインストールした端末からのみCOにアクセスできます。
                      </td>
                  </tr>
                  <template v-if="isDealer()">
                    <tr><th>フィリップス保守サービス<span class="require" /></th><td>
                      <div class="block">
                        <b-radio class="td_radio" name="crossReference" v-model="data.crossReferenceFlag" :native-value="true">有</b-radio>
                        <b-radio class="td_radio" name="crossReference" v-model="data.crossReferenceFlag" :native-value="false">無</b-radio>
                      </div></td>
                    </tr>
                    <tr><th></th><td>※可を選択した場合、申請されたユーザーを使用して参照できる患者情報を株式会社フィリップス・ジャパンも参照できることに同意したものとします。</td></tr>
                  </template>
                  <tr><th>備考</th><td><textarea v-model="data.note" style="resize:vertical;max-width:100%;" maxlength="256"/></td></tr>
              </template>
              <template v-else>
                  <tr><th>申込み状況</th>
                      <td><span :class="getTagClass4CoExternalUserStatus(data.status)" style="width:150px;">{{data.status | coExternalStatusFilter}}</span></td>
                  </tr>
                  <tr><th>医療機関名</th><td>{{data.medicalInstitutionName}}</td></tr>
                  <tr><th>診療科</th><td>{{data.department}}</td></tr>
                  <tr><th>担当支店</th><td>{{data.branchOfficeName}}</td></tr>
                  <tr><th>郵便番号</th><td>{{data.postcode}}</td></tr>
                  <tr><th>都道府県</th><td>{{data.prefecture}}</td></tr>
                  <tr><th>市町村</th><td>{{data.city}}</td></tr>
                  <tr><th>住所1</th><td>{{data.address1}}</td></tr>
                  <tr><th>住所2</th><td>{{data.address2}}</td></tr>
                  <tr><th>電話番号</th><td>{{data.telephone}}</td></tr>
                  <tr><th>クライアント認証</th><td><span v-if="data.certificationFlag">有効にする</span><span v-else>有効にしない</span></td></tr>
                  <tr v-if="isDealer()"><th>フィリップス保守サービス</th><td><span v-if="data.crossReferenceFlag">有</span><span v-else>無</span></td></tr>
                  <tr><th>備考</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td></tr>
              </template>
          </table>
          <div v-if="data.status==2" style="margin-bottom:10px;">
              <template v-if="editMode">
                  <b-button class="is-primary" v-on:click="regist">変更を申請する</b-button>
                  <b-button class="is-primary" v-on:click="cancel">キャンセル</b-button>
              </template>
              <template v-else>
                <b-button class="is-primary" v-on:click="config">編集する</b-button>
              </template>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {
  role,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
export default {
  name: "ExternalHospitalContents",
  methods: {
    config: function(){
      // 編集する
      this.editMode = true
    },
    regist: function(){
      // 変更を申請する
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        var excuteApi = this.setCoSettingFacilityManagementUpdatePOST;
        var successCallBack = this.setCoSettingFacilityManagementUpdatePOSTSuccess;
        var errorCallBack = this.setCoSettingFacilityManagementUpdatePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setCoSettingFacilityManagementUpdatePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.belongsId = this.belongsId
      return client.apis.externalCOSetting.setCoSettingFacilityManagementUpdatePOST({
        body:obj
      });
    },
    setCoSettingFacilityManagementUpdatePOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.doSearch();
    },
    setCoSettingFacilityManagementUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(){
      // キャンセル
      this.editMode = false;
      this.doSearch();
    },
    isDealer: function(){
      return this.roleId == this.role.role_dealer;
    },
    doSearch: function() {
      var excuteApi = this.getCoInstitutionPOST;
      var successCallBack = this.getCoInstitutionPOSTSuccess;
      var errorCallBack = this.getCoInstitutionPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoInstitutionPOST: function(client) {
      return client.apis.externalCOSetting.getCoInstitutionPOST({
        body:{
          careOrchestratorInstitutionId: this.careOrchestratorInstitutionId
        }
      });
    },
    getCoInstitutionPOSTSuccess: function(result) {
      var _this = this;
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (result.body.isCancel) {
        this.$dialog.alert({title: '　', message: "ケア オーケストレーターの利用申込みを行って下さい。"})
          userInfo.coType = 1
          userInfo.CoApplicationReceiptNumber = 0
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
          _this.$router.go(-1);
      } else {
        if (this.isDealer()) {
          userInfo.coType = 3
        } else {
          userInfo.coType = 2
        }
        userInfo.CoApplicationReceiptNumber = 0
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        // 検索結果取得
        this.data = result.obj
      }
    },
    getCoInstitutionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.$router.go(-1);
    }
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var branchList = this.getBranchOfficeMaster();
    branchList.unshift({});
    return {
      role: role,
      roleId: userInfo.roleId,
      data: {},
      belongsId:userInfo.belongsId,
      editMode: false,
      branchList,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      careOrchestratorInstitutionId:careOrchestratorInstitutionId,
    };
  },
  mounted() {
    this.doSearch();
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.postcode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "data.telephone"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    }
  }
};
</script>
<style lang="scss" scoped>
.urgency_caution {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/setting/ExternalHospitalContents.vue